export const SIDEMENU_DEFS: Record<string, any> = {
  'superadmin': {
    primary_menu: [
      { title: 'Dashboard', link: '/app/dashboard', icon: 'dashboard' },
      { title: 'Organizations', link: '/app/organizations', icon: 'domain' },
      { link: '/events', title: 'Events', icon: 'event_note' },
      { title: 'Users', link: '/app/Users', icon: 'people' }
    ],
    grouped_menu: [[
      'Organization', [
        { link: '/app/org', title: 'Organizational Profile', icon: 'work' },
        { link: '/app/company-settings', title: 'Company Settings', icon: 'settings' },
        { link: '/app/org-reg', title: 'Hospital Registration', icon: 'add_business' },
        { link: '/app/terminology-migration', title: 'Terminology Sync', icon: 'sync' }
      ],
      'Settings', [
        { link: '/app/profile', title: 'Profile', icon: 'person' }
      ]
    ]]
  },
  'doctor': {
    primary_menu: [
      { title: 'Dashboard', link: '/app/dashboard', icon: 'dashboard' },
      { title: 'Triage', link: '/app/triage', icon: 'health_and_safety' },
      { link: '/app/patients', title: 'Patients', icon: 'people' },
      { link: '/app/admitted-patients', title: 'Admitted Patients', icon: 'local_hospital' },
      { link: '/app/referral-requests', title: 'Referral Requests', icon: 'assignment' },
      { title: 'Invoices', link: '/app/invoice', icon: 'shopping_cart' },
      { title: 'Appointments', link: '/app/appointments', icon: 'date_range' },
      { title: 'Schedules', link: '/app/schedules', icon: 'event' },
      { title: 'Add Schedule', link: '/app/schedule', icon: 'access_time' },
      { title: 'Tasks', link: '/app/tasks', icon: 'task' },
      { link: '/events', title: 'Events', icon: 'event_note' }
    ],
    grouped_menu: [[ 'Settings', [ { link: '/app/profile', title: ' Profile', icon: 'person' } ] ]]
  },
  'primaryhealthcareprovider': {
    primary_menu: [
      { title: 'Dashboard', link: '/app/dashboard', icon: 'dashboard' },
      { link: '/app/patients', title: 'Patients', icon: 'people' },
      { link: '/app/admitted-patients', title: 'Admitted Patients', icon: 'local_hospital' },
      { link: '/app/referral-requests', title: 'Referral Requests', icon: 'assignment' },
      { title: 'Invoices', link: '/app/invoice', icon: 'shopping_cart' },
      { title: 'Appointments', link: '/app/appointments', icon: 'date_range' },
      { title: 'Schedules', link: '/app/schedules', icon: 'event' },
      { title: 'Add Schedule', link: '/app/schedule', icon: 'access_time' },
      { title: 'Tasks', link: '/app/tasks', icon: 'task' },
      { link: '/events', title: 'Events', icon: 'event_note' }
    ],
    grouped_menu: [[ 'Settings', [ { link: '/app/profile', title: ' Profile', icon: 'person' } ] ]]
  },
  'practitioner': {
    primary_menu: [
      { title: 'Dashboard', link: '/app/dashboard', icon: 'dashboard' },
      { link: '/app/patients', title: 'Patients', icon: 'people' },
      { title: 'Schedules', link: '/app/schedules', icon: 'event' },
      { title: 'Appointments', link: '/app/appointments', icon: 'date_range' },
      { title: 'Tasks', link: '/app/tasks', icon: 'task' },
      { link: '/events', title: 'Events', icon: 'event_note' }
    ],
    grouped_menu: [[ 'Settings', [ { link: '/app/profile', title: ' Profile', icon: 'person' } ] ]]
  },
  'cashier': {
    primary_menu: [
      { title: 'Dashboard', link: '/app/dashboard', icon: 'dashboard' },
      { title: 'Services', link: '/app/charges', icon: 'payments' },
      { link: '/app/patients', title: 'Patients', icon: 'people' },
      { title: 'Invoices', link: '/app/invoice', icon: 'shopping_cart' },
      { title: 'Appointments', link: '/app/appointments', icon: 'date_range' },
      { link: '/events', title: 'Events', icon: 'event_note' }
    ],
    grouped_menu: [[ 'Settings', [ { link: '/app/profile', title: ' Profile', icon: 'person' } ] ]]
  },
  'healthcareassistant': {
    primary_menu: [
      { title: 'Dashboard', link: '/app/dashboard', icon: 'dashboard' },
      { title: 'Triage', link: '/app/triage', icon: 'health_and_safety' },
      { link: '/app/patients', title: 'Patients', icon: 'people' },
      { link: '/app/admitted-patients', title: 'Admitted Patients', icon: 'local_hospital' },
      { title: 'Schedules', link: '/app/schedules', icon: 'event' },
      { title: 'Add Schedule', link: '/app/schedule', icon: 'access_time' },
      { title: 'Tasks', link: '/app/tasks', icon: 'task' },
      { title: 'Appointments', link: '/app/appointments', icon: 'date_range' },
      { link: '/app/referral-requests', title: 'Referral Requests', icon: 'assignment' },
      { link: '/app/service-requests', title: 'Service Requests', icon: 'assignment' }
    ],
    grouped_menu: [[ 'Settings', [ { link: '/app/profile', title: ' Profile', icon: 'person' } ] ]]
  },
  'nursemidwife': {
    primary_menu: [
      { title: 'Dashboard', link: '/app/dashboard', icon: 'dashboard' },
      { title: 'Triage', link: '/app/triage', icon: 'health_and_safety' },
      { link: '/app/patients', title: 'Patients', icon: 'people' },
      { link: '/app/admitted-patients', title: 'Admitted Patients', icon: 'local_hospital' },
      { title: 'Schedules', link: '/app/schedules', icon: 'event' },
      { title: 'Add Schedule', link: '/app/schedule', icon: 'access_time' },
      { title: 'Tasks', link: '/app/tasks', icon: 'task' },
      { title: 'Appointments', link: '/app/appointments', icon: 'date_range' },
      { link: '/app/referral-requests', title: 'Referral Requests', icon: 'assignment' },
      { link: '/app/service-requests', title: 'Service Requests', icon: 'assignment' },
      { link: '/app/medicine-requests', title: 'Medicine Requests', icon: 'local_pharmacy' }
    ],
    grouped_menu: [[ 'Settings', [ { link: '/app/profile', title: ' Profile', icon: 'person' } ] ]]
  },
  'alliedhealthprofessional': {
    primary_menu: [
      { title: 'Dashboard', link: '/app/dashboard', icon: 'dashboard' },
      // { title: 'Services', link: '/app/services-details', icon: 'medical_services' },
      { link: '/app/patients', title: 'Patients', icon: 'people' },
      { title: 'Schedules', link: '/app/schedules', icon: 'event' },
      { title: 'Add Schedule', link: '/app/schedule', icon: 'access_time' },
      { title: 'Tasks', link: '/app/tasks', icon: 'task' },
      { title: 'Appointments', link: '/app/appointments', icon: 'date_range' },
      { link: '/app/service-requests', title: 'Service Requests', icon: 'assignment' },
      { link: '/events', title: 'Events', icon: 'event_note' }
    ],
    grouped_menu: [[ 'Settings', [ { link: '/app/profile', title: ' Profile', icon: 'person' } ] ]]
  },
  'serviceprovider': {
    primary_menu: [
      { title: 'Dashboard', link: '/app/dashboard', icon: 'dashboard' },
      { link: '/app/patients', title: 'Patients', icon: 'people' },
      { link: '/app/admitted-patients', title: 'Admitted Patients', icon: 'local_hospital' },
      { title: 'Schedules', link: '/app/schedules', icon: 'event' },
      { title: 'Tasks', link: '/app/tasks', icon: 'task' },
      { title: 'Appointments', link: '/app/appointments', icon: 'date_range' },
      { link: '/app/service-requests', title: 'Service Requests', icon: 'assignment' },
      { link: '/app/observation-reference-ranges', title: 'Reference Ranges', icon: 'analytics' },
      { link: '/events', title: 'Events', icon: 'event_note' }
    ],
    grouped_menu: [[ 'Settings', [ { link: '/app/profile', title: ' Profile', icon: 'person' } ] ]]
  },
  'patient': {
    primary_menu: [
      { title: 'Dashboard', link: '/app/patients', icon: 'dashboard' },
      { title: 'My Appointments', link: '/app/appointments', icon: 'date_range' },
      { title: 'Book Appointment', link: '/app/book-appointment', icon: 'add_circle_outline' },
      { link: '/events', title: 'Events', icon: 'event_note' }
    ],
    grouped_menu: [[ 'Settings', [ { link: '/app/profile', title: ' Profile', icon: 'person' } ] ]]
  },
  'pharmacist': {
    primary_menu: [
      { title: 'Dashboard', link: '/app/dashboard', icon: 'dashboard' },
      { link: '/app/patients', title: 'Patients', icon: 'people' },
      { link: '/app/medicine-requests', title: 'Medicine Requests', icon: 'local_pharmacy' },
      { title: 'Medication Dispenses', link: '/app/medication-dispense', icon: 'medical_services' },
      { link: '/app/medicine-stock', title: 'Medicine Stock', icon: 'inventory' },
      { link: '/app/schedules', title: 'Schedules', icon: 'event' },
      { link: '/app/tasks', title: 'Tasks', icon: 'task' },
      { link: '/events', title: 'Events', icon: 'event_note' }
    ],
    grouped_menu: [[ 'Settings', [ { link: '/app/profile', title: ' Profile', icon: 'person' } ] ]]
  },
  'hospitaladmin': {
    primary_menu: [
      { title: 'Services', link: '/app/services-details', icon: 'medical_services' },
      // { title: 'Healthcare Services', link: '/app/healthcare-services', icon: 'medical_services' },
      { title: 'Dashboard', link: '/app/dashboard', icon: 'dashboard' },
      { link: '/app/patients', title: 'Patients', icon: 'people' },
      { link: '/app/admitted-patients', title: 'Admitted Patients', icon: 'local_hospital' },
      { link: '/app/patient-registration-data', title: 'Patient Registration', icon: 'person_add' },
      { link: '/app/practitioners', title: 'Practitioners', icon: 'person' },
      { link: '/app/medicine-stock', title: 'Medicine Stock', icon: 'inventory' },
      { link: '/app/admission-location', title: 'Admission Locations', icon: 'location_city' },
      { link: '/app/supply-stock', title: 'Supply Stock', icon: 'inventory_2' },
      { title: 'Appointments', link: '/app/appointments', icon: 'date_range' },
      { title: 'Billing Reports', link: '/app/profit-margins', icon: 'receipt_long' },
      { link: '/app/schedules', title: 'Schedules', icon: 'event' },
      { link: '/app/schedule', title: 'Add Schedule', icon: 'access_time' },
      { link: '/events', title: 'Events', icon: 'event_note' }
    ],
    grouped_menu: [[ 'Organization', [ { link: '/app/org', title: 'Hospital Profile', icon: 'work' } ], 'Settings', [ { link: '/app/profile', title: ' Profile', icon: 'person' } ] ]]
  },
  'healthcareadmin': {
    primary_menu: [
      { title: 'Dashboard', link: '/app/dashboard', icon: 'dashboard' },
      { link: '/app/patient-registration-data', title: 'Patient Registration', icon: 'person_add' },
      { title: 'Appointments', link: '/app/appointments', icon: 'date_range' },
      { title: 'Schedules', link: '/app/schedules', icon: 'event' },
      { link: '/events', title: 'Events', icon: 'event_note' }
    ],
    grouped_menu: [[ 'Settings', [ { link: '/app/profile', title: ' Profile', icon: 'person' } ] ]]
  },
  'remotedoctor': {
    primary_menu: [
      { title: 'Dashboard', link: '/app/dashboard', icon: 'dashboard' },
      { title: 'Triage', link: '/app/triage', icon: 'health_and_safety' },
      { link: '/app/consultation-requests', title: 'Consultation Requests', icon: 'chat' },
      { title: 'Schedules', link: '/app/schedules', icon: 'event' },
      { title: 'Add Schedule', link: '/app/schedule', icon: 'access_time' },
      { title: 'Appointments', link: '/app/appointments', icon: 'date_range' },
      { title: 'Tasks', link: '/app/tasks', icon: 'task' },
      { link: '/events', title: 'Events', icon: 'event_note' }
    ],
    grouped_menu: [[ 'Settings', [ { link: '/app/profile', title: ' Profile', icon: 'person' } ] ]]
  }
};

export const SIDEMENU_ROLES = Object.keys(SIDEMENU_DEFS);
